module.exports = __webpack_public_path__ + "static/media/sc2-selector-color.bdb6d06c.png";